export default __webpack_public_path__ + "static/media/nerofit-apparel-hero.788ae001.png";